'use client';

import ActivityBanner from '@/app/(activity)/components/ActivityBanner';
import { ResponsiveContext } from '@/components/Responsive/ResponsiveProvider';
import { useStore } from '@/providers/app-store-provider';
import appCommunicationManager from '@/utils/app-communication-manager';
import logger from '@/utils/client-logger';
import { EAppCommunicationFuncName } from '@/utils/enums/app-sdk';
import { EPlatform } from '@/utils/enums/platform-enum';
import { useMount, useUnmount } from 'ahooks';
import { pick } from 'lodash-es';
import { memo, useContext, useEffect } from 'react';
import usePageTrack from '../hooks/usePageTrack';
import { useShallow } from 'zustand/react/shallow';

interface IBannerBProps {
  banner: any;
}
function BannerB({ banner }: IBannerBProps) {
  const { setInAppH5, setToken, setUserInfo, refreshAccountInfo } = useStore(
    useShallow((state) =>
      pick(state, ['setInAppH5', 'setToken', 'setUserInfo', 'refreshAccountInfo']),
    ),
  );
  const { deviceType } = useContext(ResponsiveContext);
  const inAppH5 = [EPlatform.IOS, EPlatform.ANDROID].includes(deviceType);
  const { bannerRef, trackPageView, trackPageLeave, trackBannerClick } = usePageTrack({ banner });
  const handleBannerClick = (data: any) => {
    // console.log(data);
    logger.log('BannerB clicked:', data);
    trackBannerClick();
  };
  // 处理App通信逻辑
  const handleAppCommunication = async () => {
    try {
      // 注册token回调通信
      appCommunicationManager.registerCallback(
        EAppCommunicationFuncName.APP_LOGIN_SUCCESS,
        async (_token) => {
          logger.log('App登录token:', _token);
          if (_token !== 'ClearToken') {
            setToken(_token);
            // 获取用户信息
            await refreshAccountInfo();
          } else {
            // 清空当前用户信息
            setToken('');
            setUserInfo({});
          }
        },
        {},
        'BackTokenInfo' as any, // 使用BackTokenInfo的postMessage方法
      );
    } catch (e) {
      logger.error('App通信初始化失败:', e);
    }
  };
  useMount(() => {
    trackPageView();
  });
  useUnmount(() => {
    trackPageLeave();
  });
  // 检测App环境并初始化
  useEffect(() => {
    // 检测是否在App内嵌环境
    const isInApp = navigator.userAgent.includes('nextmar-xms-app');
    setInAppH5(isInApp);
  }, [setInAppH5]);

  // App通信初始化
  useEffect(() => {
    if (inAppH5) {
      handleAppCommunication();
      window.addEventListener('appView', trackPageView);
      return () => {
        window.removeEventListener('appView', trackPageView);
      };
    }
  }, [inAppH5]);
  return (
    <div ref={bannerRef}>
      <ActivityBanner
        data={banner}
        aspectRatio={banner.aspectRatio}
        onBannerClick={handleBannerClick}
      />
    </div>
  );
}
export default memo(BannerB);
